import { Currency } from "../../models/currency/Currency";

const CurrencyConst = {
    Kuna: { id: 1, name: "Kuna", sign: "kn" } as Currency,
    Euro: { id: 2, name: "Euro", sign: "EUR" } as Currency
}

export default CurrencyConst;